<script setup lang="ts">
import { useNuxtApp } from '@nuxt/bridge/dist/runtime'
const nuxtApp = useNuxtApp()
const { nuxt2Context }: any = nuxtApp
const { $env } = nuxt2Context

const props = defineProps({
  banner: {
    type: Object,
    required: true,
  },
})

</script>

<template>
  <div class="border border-solid border-bfh-border">
    <a v-if="banner.external" :href="banner.external[$i18n.locale === 'ja' ? 'ja' : 'en']" target="_blank">
      <picture>
        <source :srcset="`${$env.cdnUrl}/rsc${banner.image[$i18n.locale].pcImageName}`" media="(min-width: 768px)">
        <img :src="`${$env.cdnUrl}/rsc${banner.image[$i18n.locale].spImageName}`" />
      </picture>
    </a>
    <span v-else>
      <picture>
        <source :srcset="`${$env.cdnUrl}/rsc${banner.image[$i18n.locale].pcImageName}`" media="(min-width: 768px)">
        <img :src="`${$env.cdnUrl}/rsc${banner.image[$i18n.locale].spImageName}`">
      </picture>
    </span>
  </div>
</template>
